<template>
  <form class="login">
    <h2>Zadejte fleetové heslo</h2>
    <input class="input-paper" v-model="password" @keyup.enter="handleLogin" name="password" type="password" />
    <button class="button-paper" @click.prevent="handleLogin">Přihlásit se</button>
  </form>
  <div v-if="message" class="alert" role="alert">
     {{ message }}
  </div>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  setup() {
    const store = useStore()
    const router = useRouter()

    // Reactive data - convert from data() function
    // const company = ref('ACCR')
    const servisCode = ref('1299')
    const username = ref('fleet.dealer')
    const password = ref(null)
    const loading = ref(false)
    const message = ref(null)

    // Methods - convert to regular functions
    const handleLogin = async () => {
        // https://www.bezkoder.com/vue-3-authentication-jwt/
        loading.value = true
        //console.log('handleLogin', this);
        const user = {
                servis:   servisCode.value,
                username: username.value,
                password: password.value,
            }
        store.dispatch("auth/login", user).then(
          () => {
            router.push({name: 'dashboardMainV2'})
          },
          (error) => {
            console.log('handleLogin error', error)
            loading.value = false
            message.value =
              (error.response &&
               error.response.data &&
               error.response.data.message
              ) ||
               error.message ||
               error.toString()
          }
        )
    }

    // Return reactive data and methods for template access
    return {
      password,
      message,
      handleLogin
    }
  }
}
</script>


<style scoped>
.login,
.alert {
  margin: 20px 20px;
  display: flex;
  justify-content: center;
  gap: 8px;
}

.login input,
.login select {
  padding: 1rem;
  margin: 0 10px 0;
}

.button-paper {
  align-self: center;
  border-style: solid;
  border-width: 2px;
  color: #41403e;
  cursor: pointer;
  /*font-family: Neucha, sans-serif;*/
  font-size: 1rem;
  line-height: 2rem;
  outline: none;
  padding: .5rem;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.button-paper:hover {
  transform: translate3d(2px, 2px, 0);
}

</style>
